import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    loadingExports: false,
    exports: [],
};

const ordersSlice = createSlice({
    name: 'ordersSlice',
    initialState,
    reducers: {
        exportOrderRequest: (state) => {
            state.loading = true;
        },
        exportOrderSuccess: (state, action) => {
            state.loading = false;
            state.exports = action.payload;
        },
        exportOrderFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.exports = [];
        },
        getExportsDataRequest: (state) => {
            state.loadingExports = true;
        },
        getExportsDataSuccess: (state, action) => {
            state.loadingExports = false;
            state.exports = action.payload;
        },
        getExportsDataFailure: (state) => {
            state.loadingExports = false;
        },
    },
});

export default ordersSlice.reducer;

export const {
    exportOrderRequest,
    exportOrderSuccess,
    exportOrderFailure,
    getExportsDataRequest,
    getExportsDataSuccess,
    getExportsDataFailure,
} = ordersSlice.actions;
